import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y1952 = new LunarYear(
  moment.tz('1952-01-27 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10, 11, 12],
  [29, 30, 29, 30, 29, 30, 30, 29, 30, 29, 30, 29, 30],
  5,
)

export default Y1952
